import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Toaster from './components/Toaster';
import { startPerfWatch } from './lib/perfWatch';
import { installCellCopy } from './lib/cellCopy';
import './styles/globals.css';

// 느린 PC 의 화면 멈춤(0.2초+)을 모아 1분마다 서버 로그로 — 「마우스가 느려졌다」 실측용.
startPerfWatch();
// 칸 복사 = 눌러 고르고 Ctrl+C(#250).
installCellCopy();

// 배포 뒤 옛 화면이 사라진 청크를 부르면 흰 화면에 멈춘다 — 설치형 기사앱엔 새로고침 버튼도 없다
// (YDYOPS #JN82TEFR). 한 번만 새로고침한다(세션당 1회 — 무한 새로고침이 흰 화면보다 나쁘다).
window.addEventListener('vite:preloadError', () => {
  try {
    if (sessionStorage.getItem('preload-reloaded') === '1') return;
    sessionStorage.setItem('preload-reloaded', '1');
  } catch {
    return;
  }
  location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    {/* #390 저장·등록 결과 알림 — 팝업보다 위, 화면 위 가운데. */}
    <Toaster />
  </StrictMode>,
);
